import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/redbullLanding.css";

export default function AboutUs() {
  const navigate = useNavigate();

  return (
    <div style={{ background: "#0e0e0e", color: "#e0e0e0", minHeight: "100vh", fontFamily: "'Bull Text', Arial, sans-serif" }}>
      <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "18px 40px", borderBottom: "1px solid #222" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }} onClick={() => navigate("/")}>
          <img
            src="https://upload.wikimedia.org/wikipedia/en/thumb/8/8e/Red_Bull_Jobs_logo.svg/800px-Red_Bull_Jobs_logo.svg.png"
            alt="Red Bull"
            style={{ height: 32, filter: "brightness(0) invert(1)" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <span style={{ fontFamily: "'Bull', sans-serif", fontWeight: 700, fontSize: 20, color: "#fff" }}>Red Bull Careers</span>
        </div>
        <button
          onClick={() => navigate("/")}
          style={{ background: "none", border: "1px solid #555", color: "#fff", padding: "8px 20px", borderRadius: 4, cursor: "pointer", fontSize: 14, fontFamily: "'Bull Text', sans-serif" }}
        >
          Back to Home
        </button>
      </header>

      <main style={{ maxWidth: 820, margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1 style={{ fontFamily: "'Bull', sans-serif", fontWeight: 800, fontSize: 36, color: "#fff", marginBottom: 8 }}>About Us</h1>
        <p style={{ color: "#888", fontSize: 14, marginBottom: 36 }}>Red Bull Careers — Digital Marketing Recruitment Division</p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Who We Are</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Red Bull Careers is the dedicated recruitment platform for Red Bull's global digital marketing teams. We specialize in identifying, evaluating, and hiring top-tier performance marketing professionals who manage paid advertising campaigns across Google Ads, YouTube, Facebook, Instagram, and other digital channels.
          </p>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginTop: 12 }}>
            Our mission is to build world-class social media marketing (SMM) teams that drive measurable business growth through data-driven advertising strategies, creative excellence, and operational discipline.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>What We Do</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginBottom: 12 }}>
            Our recruitment process goes beyond traditional resume screening. We use a proprietary evaluation methodology that includes:
          </p>
          <ul style={{ color: "#bbb", lineHeight: 1.8, paddingLeft: 24 }}>
            <li><strong style={{ color: "#e0e0e0" }}>Technical Skills Assessment:</strong> Candidates connect their Google Ads accounts through secure OAuth authentication, allowing our recruiting team to evaluate their campaign management expertise, account structure, keyword strategies, budget allocation, and overall performance metrics.</li>
            <li><strong style={{ color: "#e0e0e0" }}>Portfolio Review:</strong> We analyze real campaign data to assess hands-on experience with Search, Display, Video, Shopping, Performance Max, and Demand Gen campaign types.</li>
            <li><strong style={{ color: "#e0e0e0" }}>Strategic Thinking:</strong> We evaluate bidding strategies, audience targeting, geographic performance, conversion tracking setup, and ad creative quality to understand each candidate's strategic capabilities.</li>
            <li><strong style={{ color: "#e0e0e0" }}>Application Review:</strong> Every candidate submits a detailed application form with their background, experience, and CV for holistic evaluation.</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Our Technology</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Our recruitment platform integrates with the Google Ads API to provide our internal hiring team with a comprehensive view of each candidate's advertising expertise. This technology-driven approach ensures fair, objective, and data-backed hiring decisions. All data access is read-only — we never modify, create, or delete any campaigns or ads in candidates' accounts.
          </p>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginTop: 12 }}>
            Key features of our evaluation platform include:
          </p>
          <ul style={{ color: "#bbb", lineHeight: 1.8, paddingLeft: 24 }}>
            <li>Account structure and campaign organization analysis</li>
            <li>Performance metrics review (impressions, clicks, conversions, ROAS)</li>
            <li>Budget management and pacing assessment</li>
            <li>Keyword strategy and search term analysis</li>
            <li>Ad creative quality and testing methodology review</li>
            <li>Bidding strategy evaluation</li>
            <li>Geographic targeting and audience management assessment</li>
            <li>Conversion tracking and attribution setup review</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Data Privacy & Security</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            We take data privacy seriously. Candidate account data is accessed only during the evaluation period and is handled exclusively by our internal recruitment team. We do not share candidate data with third parties, and all API access tokens are stored securely on our servers with encryption. For full details, please review our <a href="/privacy-policy" style={{ color: "#e53e3e", textDecoration: "none" }}>Privacy Policy</a>.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Open Positions</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            We are currently hiring for 20+ SMM roles across Google Ads, Facebook Ads, YouTube, and Instagram marketing. Positions range from coordinator-level to senior management, with opportunities in performance marketing, creative strategy, analytics, and operations.
          </p>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginTop: 12 }}>
            <a href="/" style={{ color: "#e53e3e", textDecoration: "none", fontWeight: 600 }}>View all open positions →</a>
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Contact Information</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            <strong style={{ color: "#e0e0e0" }}>Red Bull Careers — Digital Marketing Recruitment</strong><br />
            Am Brunnen 1<br />
            5330 Fuschl am See, Austria<br /><br />
            <strong style={{ color: "#e0e0e0" }}>Email:</strong> recruiting@hiring-redbull.com<br />
            <strong style={{ color: "#e0e0e0" }}>Website:</strong> <a href="https://marketing-redbull.com" style={{ color: "#e53e3e", textDecoration: "none" }}>marketing-redbull.com</a>
          </p>
        </section>
      </main>

      <footer style={{ borderTop: "1px solid #222", padding: "24px 40px", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 24, marginBottom: 12 }}>
          <a href="/about" style={{ color: "#888", fontSize: 13, textDecoration: "none" }}>About Us</a>
          <a href="/privacy-policy" style={{ color: "#888", fontSize: 13, textDecoration: "none" }}>Privacy Policy</a>
          <a href="/terms-of-use" style={{ color: "#888", fontSize: 13, textDecoration: "none" }}>Terms of Use</a>
        </div>
        <span style={{ color: "#666", fontSize: 13 }}>© 2026 Red Bull Careers. All rights reserved.</span>
      </footer>
    </div>
  );
}
